import styled from "styled-components";

import { BrazeSelect } from "@components/BrazeSelect";

export const CountryCodeSelectContainer = styled(BrazeSelect)<{ isDisabled?: boolean }>`
  margin-right: 10px;
  flex: 0 0 130px;
  ${({ isDisabled }) =>
    isDisabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;
